// extracted by mini-css-extract-plugin
export var textInput = "_i8-0";